import { render, staticRenderFns } from "./Attainments.vue?vue&type=template&id=30555b3a&"
import script from "./Attainments.vue?vue&type=script&lang=js&"
export * from "./Attainments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports